<template>
  <div class="Home">
    <Navbar></Navbar>
    <RouterView></RouterView>
    <TalkiiFooter></TalkiiFooter>
  </div>
</template>

<script>
import { getAuth } from "firebase/auth";
import { doc, getDoc } from 'firebase/firestore';

import { db } from "@/firebase/firebaseInit";
import Navbar from "@/components/Navbar";
import TalkiiFooter from "@/components/TalkiiFooter";

const auth = getAuth();

export default {
  name: "Home",
  components: {
    Navbar: Navbar,
    TalkiiFooter: TalkiiFooter,
  },
  methods: {
    loadFirebaseUser() {
      if (!auth.currentUser) {
        // this.isLoggedIn = false;
      } else {
        //get user id from firebase auth
        this.userId = auth.currentUser.uid;
        // this.isLoggedIn = true;
        
        getDoc(doc(db, "users", this.userId))
         .then((doc) => {
            if (doc.exists) {
              console.log("firebase GET userDoc SUCCESS");
              // save userDoc in store
              this.$store.commit("setUser", doc.data());
            } else {
              // doc.data() will be undefined in this case
              console.log("UserDoc not found!");
            }
          })
          .catch((error) => {
            console.log("firebase GET userDoc ERROR: ", error);
          });
      }
    },
  },
  computed: {
    userDoc: {
      get() {
        return this.$store.getters.getUser;
      },
    },
  },
  created() {
    this.loadFirebaseUser();

    //set dashboard mode to false
    this.$store.commit("setIsDash", false);
  },
};
</script>

<style scoped></style>
